import http from '@/plugins/axios/axios';

export default class FuncionarioPesquisaService {   

    listarContratos(requisicao) { 
        return http.post('/api/funcionario-pesquisa/listar-contratos', requisicao);
    }

    buscarFuncionarios(requisicao) { 
        return http.post('/api/funcionario-pesquisa/buscar-funcionarios', requisicao);
    }

    buscarFuncionariosCrachaNome(requisicao) { 
        return http.post('/api/funcionario-pesquisa/buscar-funcionarios-cracha-nome', requisicao);
    }

    buscarFuncionariosContrato(requisicao) { 
        return http.post('/api/funcionario-pesquisa/buscar-funcionarios-contrato', requisicao);
    }

    buscarFuncionariosContratoCrachaNome(requisicao) { 
        return http.post('/api/funcionario-pesquisa/buscar-funcionarios-contrato-cracha-nome', requisicao);
    }   
    
}